// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"9f71ea59","324":"621a03b3","529":"8efe9d58"}[chunkId] + ".chunk.js";
};